import { useState } from "react";
import { useParams } from "react-router-dom";
import useFetchReports from "../../hooks/useFetchReports";
import FilterExportSection from "./FilterExportSection";
import FilterExportResultsSection from "./FilterExportResultsSection";
import { FetchedReportData, ReportStatusType } from "../../../types";
import { useReportFilter } from "../../hooks/useReportFilter";
import useReportDetails from "../../hooks/UseReportDetails";

const AdminDashboard = ({ view }: { view?: "dashboard" | "reportView" }) => {
  const { id } = useParams<{ id: string }>();
  const { reports, fetchingReports, fetchReportsError } = useFetchReports();

  const {
    reportDetails,
    setReportDetails,
    loading: fetchingReportDetails,
    error: fetchReportDetailsError,
  } = useReportDetails(id);

  const [activeMode, setActiveMode] = useState<"filter" | "export">("filter");
  const [filteredReports, setFilteredReports] = useState<
    FetchedReportData[] | undefined
  >(reports);

  const { filtering } = useReportFilter();

  const loading = fetchingReports || fetchingReportDetails || filtering;
  const error = fetchReportsError || fetchReportDetailsError;

  const handleStatusUpdate = (
    reportId: string,
    newStatus: ReportStatusType
  ) => {
    // Update the report in filteredReports
    if (filteredReports) {
      const updatedFilteredReports = filteredReports.map((report) =>
        report._id === reportId ? { ...report, status: newStatus } : report
      );
      setFilteredReports(updatedFilteredReports);
    }

    // If we are viewing a report's details, update that as well
    if (reportDetails && reportDetails._id === reportId) {
      setReportDetails({ ...reportDetails, status: newStatus });
    }
  };

  return (
    <div className="w-full h-full flex justify-center xs:flex-row gap-x-2 sm:gap-x-5 lg:gap-x-[60px] mx-auto max-w-[calc(100%-64px)] xl:max-w-[1200px] xl:gap-x-[90px]">
      <FilterExportSection
        activeMode={activeMode}
        setActiveMode={setActiveMode}
        setFilteredReports={setFilteredReports}
      />

      <FilterExportResultsSection
        activeMode={activeMode}
        reports={reports}
        filteredReports={filteredReports}
        setFilteredReports={setFilteredReports}
        reportDetails={reportDetails}
        setReportDetails={setReportDetails}
        loading={loading}
        error={error}
        handleStatusUpdate={handleStatusUpdate}
      />
    </div>
  );
};

export default AdminDashboard;
